/**
 * clients-status-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ClientsStatusRequest extends ReplyVerifyingMessage
{
    public tag : MessageTag = MessageTag.REQ_STATUS_CLIENTS;
	public static tag : MessageTag = MessageTag.REQ_STATUS_CLIENTS;

    public verifyReply (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_STATUS_CLIENTS);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/clients-status-request.ts